import React from 'react';
import { Box } from '@mui/material';

/** Cores amostradas na arte GreeningAI (folha + nome). */
export const GREENING_WORDMARK_GREEN = '#48C058';
export const GREENING_WORDMARK_BLUE = '#4098E0';

interface Props {
  fontWeight?: number;
  fontSize?: string | number;
  onDark?: boolean;
}

/** «Greening» verde + «AI» azul. */
export function GreeningBrandLabel({ fontWeight = 600, fontSize, onDark }: Props) {
  const green = onDark ? '#C8F5D0' : GREENING_WORDMARK_GREEN;
  const blue = onDark ? '#D6ECFF' : GREENING_WORDMARK_BLUE;
  return (
    <Box component="span" sx={{ fontWeight, fontSize, whiteSpace: 'nowrap', textTransform: 'none' }}>
      <Box component="span" sx={{ color: green }}>
        Greening
      </Box>
      <Box component="span" sx={{ color: green }}>.</Box>
      <Box component="span" sx={{ color: blue }}>
        AI
      </Box>
    </Box>
  );
}

export function GreeningChatTitle({ variant = 'h6', onDark }: { variant?: 'h6' | 'subtitle1' | 'body2'; onDark?: boolean }) {
  const weights = { h6: 700, subtitle1: 700, body2: 600 };
  const sizes = { h6: undefined, subtitle1: undefined, body2: '0.9rem' };
  return (
    <Box component="span" sx={{ fontWeight: weights[variant], fontSize: sizes[variant], color: onDark ? '#fff' : 'inherit' }}>
      Chat com o agente <GreeningBrandLabel fontWeight={weights[variant]} fontSize={sizes[variant]} onDark={onDark} />
    </Box>
  );
}

export default GreeningBrandLabel;
